import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@constants/queryKeys.constant';
import { EStaleTime } from '@enums/staleTime.enum';

import { callsService } from './service';

export function callsListQueryOptions() {
  return queryOptions({
    queryFn: () => callsService.getCallList(),
    queryKey: queryKeys.calls.list(),
    staleTime: EStaleTime.TwoMinutes,
  });
}
